// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__CBda_","Open":"SideDrawer_Open__1HjBF","Close":"SideDrawer_Close__1Y3nI","Logo":"SideDrawer_Logo__1B6LV"};